// Types para el CONTEXT de proyectos
export const FORMULARIO_PROYECTO = 'FORMULARIO_PROYECTO';
export const FORMULARIO_EDITAR = 'FORMULARIO_EDITAR';
export const OBTENER_PROYECTOS = 'OBTENER_PROYECTOS';
export const OBTENER_ULTIMOS_CAMBIOS = 'OBTENER_ULTIMOS_CAMBIOS';
export const ULTIMO_CAMIBIO = 'ULTIMO_CAMIBIO';
export const AGREGAR_PROYECTO = 'AGREGAR_PROYECTO';
export const VALIDACION_FORMULARIO = 'VALIDACION_FORMULARIO';
export const PROYECTO_ACTUAL = 'PROYECTO_ACTUAL';
export const ELIMINAR_PROYECTO = 'ELIMINAR_PROYECTO';
export const ACTUALIZAR_PROYECTO = 'ACTUALIZAR_PROYECTO';
export const CAMBIAR_VISTA = 'CAMBIAR_VISTA';
export const CAMBIAR_PROYECTO = 'CAMBIAR_PROYECTO';
export const CAMBIAR_ALTURA_CONTENEDOR = 'CAMBIAR_ALTURA_CONTENEDOR';
export const REINICIAR_PROYECTO_STATE = 'REINICIAR_PROYECTO_STATE';

// Types para el CONTEXT de tareas
export const TAREAS_PROYECTO = 'TAREAS_PROYECTO';
export const AGREGAR_TAREA = 'AGREGAR_TAREA';
export const VALIDACION_CAMPO = 'VALIDACION_CAMPO';
export const ELIMINAR_TAREA = 'ELIMINAR_TAREA';
export const TAREA_SELECCIONADA = 'TAREA_SELECCIONADA';
export const ACTUALIZAR_TAREA = 'ACTUALIZAR_TAREA';
export const LIMPIAR_TAREA = 'LIMPIAR_TAREA';
export const VER_TAREA = 'VER_TAREA';
export const TAREA_ACTUAL = 'TAREA_ACTUAL';
export const OBTENER_DESCRIPCIONES = 'OBTENER_DESCRIPCIONES';
export const AGREGAR_DESCRIPCION = 'AGREGAR_DESCRIPCION';
export const ELIMINAR_DESCRIPCION = 'ELIMINAR_DESCRIPCION';
export const DESCRIPCION_SELECCIONADA = 'DESCRIPCION_SELECCIONADA';
export const LIMPIAR_DESCRIPCION = 'LIMPIAR_DESCRIPCION';
export const ACTUALIZAR_DESCRIPCION = 'ACTUALIZAR_DESCRIPCION';
export const CAMBIAR_FORMULARIO = 'CAMBIAR_FORMULARIO';
export const REINICIAR_TAREA_STATE = 'REINICIAR_TAREA_STATE';

// Types para el CONTEXT de barra principal
export const OPCIONES_MENU = 'OPCIONES_MENU';
export const VER_CUENTAS = 'VER_CUENTAS';
export const OBTENER_USUARIOS = 'OBTENER_USUARIOS';
export const ELIMINAR_USUARIO = 'ELIMINAR_USUARIO';
export const REINICIAR_BPPL_STATE = 'REINICIAR_BPPL_STATE';

// Types para el CONTEXT de alerta
export const MOSTRAR_ALERTA = 'MOSTRAR_ALERTA';
export const OCULTAR_ALERTA = 'OCULTAR_ALERTA';

// Types para el CONTEXT de autenticacion
export const REGISTRO_EXITOSO = 'REGISTRO_EXITOSO';
export const REGISTRO_ERROR = 'REGISTRO_ERROR';
export const OBTENER_USUARIO = 'OBTENER_USUARIO';
export const CARGANDO_LOGIN = 'CARGANDO_LOGIN';
export const LOGIN_EXITOSO = 'LOGIN_EXITOSO';
export const LOGIN_ERROR = 'LOGIN_ERROR';
export const CERRAR_SESION = 'CERRAR_SESION';
export const OCULTAR_MENSAJE_ALERTA = 'OCULTAR_MENSAJE_ALERTA';